import Image from 'next/image'
import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import TracedImage from '@/assets/about-us/Traced-Image.svg'
const _data = [
	{ title: 'Startup Award 2023', description: 'Best Online Marketplace Solution Provider of the Year Award' },
	{ title: 'Entrepreneur Awards 2023', description: 'B2B Startup of the Year' },
	{ title: 'BCC&I-TATA Steelium MSME Excellence Award 2023', description: 'Rising Startup of the Year Award 2021-23' },
	{ title: `Indian Achievers' Awards 2022-23`, description: 'Emerging Company Award' },
	{ title: `Indian Achievers' Awards 2022-23`, description: 'RP Singh - Co-Founder' },
	{ title: `Times 40 Under 40`, description: 'Pulkit Baldev- Co-Founder' },
]
const MetalbookWinner = () => {
	return (
		<Container fluid className='p-0'>
			<Row className='metalbook-winner-container m-0'>
				{_data?.map((item, index) => (
					<Col xs={12} md={6} lg={4} key={index} className='d-flex'>
						<div className='winner-card'>
							<Image src={TracedImage} alt='...' />
							<h4 className='primary-text'>{item?.title}</h4>
							<p>{item?.description}</p>
						</div>
					</Col>
				))}
			</Row>
		</Container>
	)
}

export default MetalbookWinner
